import {Injectable, signal, WritableSignal} from '@angular/core';
import {User, UserDetailsResponse} from '@models/user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  private user$: WritableSignal<User | null> = signal<User | null>(null);
  private token$: WritableSignal<string | null> = signal<string | null>(null);

  private tokenKey: string = 'auth_token';
  private userKey: string = 'user_info';

  constructor() {
    this.loadFromStorage();
  }

  private loadFromStorage(): void {
    const token = localStorage.getItem(this.tokenKey);
    if (token) {
      this.token$.set(token);
    }
    const userString = localStorage.getItem(this.userKey);
    if (userString) {
      const user = JSON.parse(userString);
      this.user$.set(user);
    }
  }

  setUser(user: UserDetailsResponse): void {
    this.user$.set(user);
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }

  setToken(token: string): void {
    this.token$.set(token);
    localStorage.setItem(this.tokenKey, token);
  }

  getUser(): WritableSignal<User | null> {
    return this.user$;
  }

  getToken(): WritableSignal<string | null> {
    return this.token$;
  }

  deleteToken(): void {
    this.token$.set(null);
    this.user$.set(null);
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
  }

}
